// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1WzI3","info":"UpdateTermsInfo_info__cb_8c"};